namespace TabAurous.Production {
    export namespace WIPMovementSelectService {
        export const baseUrl = 'Production/WIPMovementSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPMovementRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPMovementSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPMovementSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
